module.exports = __webpack_public_path__ + "static/img/56.e1e5ab8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/56.png
// module id = WBsm
// module chunks = 1